app.controller(
    'BioCorrectionController', ['$scope', '$rootScope', '$stateParams', '$translate', '$window', 'BioService', 'SideBarService', 'HelperService', BioCorrectionController]
);

function BioCorrectionController($scope, $rootScope, $stateParams, $translate, $window, BioService, SideBarService, HelperService) {
    var vm = this;
    vm.ActiveDescription = {};
    vm.ActiveDescriptionId = 0;

    vm.Bio = {
        DescriptionPositionList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
    };
    vm.ActiveDescriptionVm =
        {
            Clients: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
            QualificationList: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
            DescriptionNewPositionText: '1'
        };
    vm.ActiveDescriptionVmOrigin = angular.copy(vm.ActiveDescriptionVm);

    vm.StatusList4WorkflowDescription = ['', '', '', '', '', ''];
    $scope.edit = {};
    $scope.item = {};

    $scope.contentTranslate = null;

    $scope.classifications = [];

    $scope.item.disaplayName = $scope.item.name || ($scope.item.firstName || $scope.item.lastName);


    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    $translate.use($rootScope.LangForInterface);

    if ($stateParams.id) {
        vm.ParamBioId = $stateParams.id;
    }
    else {
        vm.ParamBioId = 1;
    }

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    initController();

    function initController() {        
        loadBio(vm.ParamBioId, $scope.CurrentLang, "", $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    }

    function loadBio(bioId, lang, lang2, index, sortKey, reverse) {
        BioService.GetBio(bioId, lang, lang2, index, sortKey, reverse)
            .then(function (bio) {
                vm.Bio = bio;
                vm.BioOrigin = angular.copy(vm.Bio);

                if (vm.Bio.DescriptionList.length > 0) {
                    vm.ActiveDescriptionId = 0;
                    vm.ActiveDescription = vm.Bio.DescriptionList[vm.ActiveDescriptionId];
                    vm.GetDescriptionVm();
                }
                $rootScope.Clients = bio.ClientList;
                $rootScope.Comments = bio.CommentList;
                $rootScope.SideBar = bio.SideBar;

                $rootScope.CurrentObjectId = bioId;
                $rootScope.CurrentPageType = $rootScope.EnumLinkType.Bio;
                $rootScope.CurrentObjectStatus = bio.CurrentBioStatus;
                $rootScope.SideBar.CurrentObjectStatus = bio.CurrentBioStatus;
                $rootScope.SideBar.StatusList = $rootScope.StatusList4WorkflowObjectSt;
                
                $rootScope.SideBar.bioVmProfessionTranslation = bio.ProfessionTranslation;

                vm.GetAssociatedPlacesOnSideBar();
                vm.GetAssociatedZonesOnSideBar();
                $rootScope.getJobList();

                vm.StatusList4WorkflowDescription = angular.copy($rootScope.StatusList4WorkflowDescription);
                //$scope.ChangeZoneById(vm.ParamZoneId);
            });
    }

    vm.UpdateBio = function () {

        BioService.UpdateBio(vm.Bio.Bio)
            .then(function (data) {


            });
    }

    vm.UpdateDescription = function () {
        if (vm.ActiveDescriptionVm.Description != undefined) {
            HelperService.UpdateDescription(vm.Bio.DescriptionList[vm.ActiveDescriptionId])
                .then(function (data) {


                });
        }
    }

    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "Bio", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);

                  },
                function error(data) {
                });
    };

    $rootScope.AddComment = function AddComment(CurrentObjectId) {
        promiseAddComment = SideBarService.AddComment(vm.Bio.SideBar.CommentEdit, vm.Bio.Bio.BioId, $stateParams.lang, $rootScope.EnumLinkType.Bio);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {
        console.log(vm.Bio);

        SideBarService.SaveDiffuseur($rootScope.Clients, vm.Bio.Bio.BioId, $stateParams.lang, $rootScope.EnumLinkType.Bio);
    };

    vm.OpenInOtherLang = function (lang) {
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/correction/bio?id=' + vm.Bio.Bio.BioId + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }

    vm.GetDescriptionVm = function () {
        HelperService.GetDescriptionVmWithSort(vm.Bio.DescriptionList[vm.ActiveDescriptionId].DescriptionId, vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, 0, $scope.CurrentLang)
            .then(function (desc) {
                vm.ActiveDescriptionVm = desc;
                vm.ActiveDescriptionVmOrigin = angular.copy(vm.ActiveDescriptionVm);
            });
    }

    vm.GetAssociatedPlacesOnSideBar = function () {
        HelperService.GetAssociatedPlacesOnSideBar(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang, true)
            .then(function (data) {
                $rootScope.AssociatedPlaces = data;
            });
    }

    $rootScope.SaveAssociatedPlaces = function SaveAssociatedPlaces() {
        promiseAddComment = SideBarService.SaveAssociatedPlaces(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang, $rootScope.AssociatedPlaces);
    };

    vm.GetAssociatedZonesOnSideBar = function () {
        HelperService.GetAssociatedZonesOnSideBar(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang)
            .then(function (data) {
                $rootScope.AssociatedZones = data;
            });
    }

    $rootScope.SaveAssociatedZones = function SaveAssociatedZones() {
        promiseAddComment = SideBarService.SaveAssociatedZones(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang, $rootScope.AssociatedZones);
    };

    $rootScope.SaveQualificationAssociees = function () {
        HelperService.SaveQualificationAssociees(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $scope.CurrentLang, $rootScope.SideBar.QualificationList);
    }

    $rootScope.SaveJobAssocie = function () {
        HelperService.SaveJobAssocie(vm.Bio.Bio.BioId, $rootScope.EnumLinkType.Bio, $rootScope.SideBar.bioVmProfessionTranslation);
    }

    vm.PreviousDesc = function () {
        if (vm.Bio.DescriptionList.length > 0 && vm.ActiveDescriptionId > 0) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId - 1;
            vm.GetDescriptionVm();
        }
    }

    vm.NextDesc = function () {
        if (vm.Bio.DescriptionList.length > 0 && vm.ActiveDescriptionId < vm.Bio.DescriptionList.length - 1) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId + 1;
            vm.GetDescriptionVm();
        }
    }

    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {
        SideBarService.UpdateObjectStatus(status, objectId, $scope.CurrentLang, $rootScope.EnumLinkType.Bio);
    };

    vm.UpdateDescriptionStatus = function () {
        if (vm.ActiveDescriptionVm.Description != undefined) {
            //console.log("test: " +vm.ActiveDescriptionVm.Description.DescriptionId + " : " + $scope.CurrentLang + " : " +vm.ActiveDescriptionVm.DescriptionStatus);
            HelperService.UpdateDescriptionStatus(vm.ActiveDescriptionVm.Description.DescriptionId, $scope.CurrentLang, vm.ActiveDescriptionVm.DescriptionStatus);
        }
    }

    vm.UpdateDescriptionPosition = function () {
        if (vm.ActiveDescriptionVm.Description != undefined) {
            HelperService.UpdateDescriptionPosition(vm.Bio.Bio.BioId, vm.ActiveDescriptionVm.Description.DescriptionId, vm.ActiveDescriptionVm.DescriptionCurrentPositionText, vm.ActiveDescriptionVm.DescriptionNewPositionText, $rootScope.EnumLinkType.Bio);
        }
    }

    vm.AddDescriptionToClient = function () {
        HelperService.AddDescriptionToClient(vm.ActiveDescriptionVm.Clients, vm.ActiveDescriptionVm.Description.DescriptionId);
    }

    vm.AddQualificationToDescription = function () {
        HelperService.AddQualificationToDescription(vm.ActiveDescriptionVm.QualificationList, vm.ActiveDescriptionVm.Description.DescriptionId);
    }

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareInfoByDefaultMail('emailShareBioPracticalInfo', $translate.instant('emailShareBioPracticalInfo').replaceAll('&amp;', '&'), vm.Bio);
    }

    $rootScope.shareFicheComplete = function () {
        $rootScope.shareInfoPratique();
    }
}